import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StatusMessageResultDto } from 'src/app/pages/general/project.service';
import { BaseService, RequestOptions } from 'src/app/services/base.service';
import { BookmarkElement } from '../models/bookmark-element.model';
import { Bookmark } from '../models/bookmark.model';
import { BookmarksGroup } from '../models/bookmarks-group.model';

export namespace Bookmarks {
	export enum LocalStorageKeys {
		BookmarksGroupPrefix = 'perito_bookmarks_bookmarksGroup',
		BookmarksPrefix = 'perito_bookmarks_bookmarks',
		BookmarkElementsPrefix = 'perito_bookmarks_bookmarkElements-default',
	}
}

@Injectable({
	providedIn: 'root'
})
export class BookmarkService {

	private static readonly REQUEST_TOP_PATH: string = "Bookmark";

	public getGenericKeyBookmarksGroup(id: number | string, requestOptions?: RequestOptions): Observable<BookmarksGroup> {
		const requestEndpoint: string = "GetGenericKeyBookmarksGroup";

		let url = `${BookmarkService.REQUEST_TOP_PATH}/${requestEndpoint}?id=${id}`;

		return this._baseService.get(
			url,
			requestOptions
		);
	}

	public createGenericKeyBookmarksGroup(id: number | string, routeId: number, requestOptions?: RequestOptions): Observable<BookmarksGroup> {
		const requestEndpoint: string = "CreateGenericKeyBookmarksGroup";

		let url = `${BookmarkService.REQUEST_TOP_PATH}/${requestEndpoint}?id=${id}&routeId=${routeId}`;

		return this._baseService.post(
			url,
			undefined,
			requestOptions
		);
	}

	public createBookmark(bookmarkData: { bookmark: Bookmark, bookmarkElements: BookmarkElement[] }, requestOptions?: RequestOptions): Observable<Bookmark> {
		const requestEndpoint: string = "CreateBookmark";

		let url = `${BookmarkService.REQUEST_TOP_PATH}/${requestEndpoint}`;

		return this._baseService.post(
			url,
			bookmarkData,
			requestOptions
		);
	}

	public updateBookmark(bookmark: Bookmark, requestOptions?: RequestOptions): Observable<StatusMessageResultDto> {
		const requestEndpoint: string = "UpdateBookmark";

		let url = `${BookmarkService.REQUEST_TOP_PATH}/${requestEndpoint}`;

		return this._baseService.post(
			url,
			bookmark,
			requestOptions
		);
	}

	public deleteBookmark(bookmark: Bookmark, requestOptions?: RequestOptions): Observable<StatusMessageResultDto> {
		const requestEndpoint: string = "DeleteBookmark";

		let url = `${BookmarkService.REQUEST_TOP_PATH}/${requestEndpoint}`;

		return this._baseService.post(
			url,
			bookmark,
			requestOptions
		);
	}

	public updateBookmarkElements(bookmarkData: { bookmark: Bookmark, bookmarkElements: BookmarkElement[] }, requestOptions?: RequestOptions): Observable<StatusMessageResultDto> {
		const requestEndpoint: string = "UpdateBookmarkElements";

		let url = `${BookmarkService.REQUEST_TOP_PATH}/${requestEndpoint}`;

		return this._baseService.post(
			url,
			bookmarkData,
			requestOptions
		);
	}

	

	constructor(
		private _baseService: BaseService,
	) { }
}
